module.exports = __webpack_public_path__ + "img/risk-icon.074d91dd.svg";